// @flow
import React from 'react';
import glamorous from 'glamorous';
import { css } from 'glamor';

type Props = {
  className?: string,
};

const defaultProps = {
  className: undefined,
};

const spin = css.keyframes({
  to: { transform: 'rotate(360deg)' },
});

const StyledSvg = glamorous.svg({
  animation: `${spin} 0.2s steps(4, end) infinite`,
});

function BlockSpinner({ className }: Props) {
  return (
    <StyledSvg viewBox="0 0 20 20" width={18} height={18} className={className}>
      <rect x={0} y={0} width={12} height={12} fill="currentColor" />
      <rect x={14} y={0} width={6} height={6} fill="currentColor" opacity={0.75} />
      <rect x={14} y={14} width={6} height={6} fill="currentColor" opacity={0.5} />
      <rect x={0} y={14} width={6} height={6} fill="currentColor" opacity={0.25} />
    </StyledSvg>
  );
}

BlockSpinner.defaultProps = defaultProps;

export default BlockSpinner;
